import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, ControlLabel, FormControl, InputGroup, Button, HelpBlock, ProgressBar } from 'react-bootstrap';
import Validations from '../../utils/Validations';

class InputPassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            score: 0,
            dirty: false,
            showPassword: false
        };
    }

    checkPassword = (password) => {
        if (!password)
            return false;

        if (this.props.compareValue != null)
            return password === this.props.compareValue;

        if (this.props.code == null) {
            return Validations.password(password) === 4;
        }

        if (this.props.code != null && this.props.code.length == 6 && isNaN(this.props.code) == false) {
            return true
        }

    }

    onValueChange = (ev) => {
        let value = ev.target.value;

        if (this.props.onChange != null)
            this.props.onChange(value, this.checkPassword(value));

        this.setState({
            dirty: true,
            score: Validations.password(value)
        });
    }

    getValidationState = () => {
        if (this.state.dirty || this.props.forceValidation) {
            if (this.checkPassword(this.props.value))
                return 'success';
            else
                return 'error';
        }
        else return '';
    }

    onEyeClick = () => {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    render() {

        let helpBlock = '';
        let isCompare = this.props.compareValue == null;
        if (isCompare)
            helpBlock = 'Debe contener al menos 8 caracteres, una letra mayúscula, un número. Los siguientes símbolos son opcionales: @ # $ % & + =';
        else if (!this.checkPassword(this.props.value) && (this.state.dirty || this.props.forceValidation))
            helpBlock = 'Las contraseñas deben coincidir';

        if (this.props.code != null) {
            helpBlock ='Para garantizar la seguridad de su cuenta, por favor ingrese el código de 6 dígitos que aparece en la aplicación de autenticación de su dispositivo';
        }

        return (
            <FormGroup validationState={this.getValidationState()}>
                {this.props.current != null && <ControlLabel>Contraseña Actual</ControlLabel>}
                {this.props.current == null && this.props.compareValue == null && this.props.code == null &&
                    <ControlLabel>Nueva Contraseña</ControlLabel>}
                {this.props.compareValue != null && <ControlLabel>Repetir Contraseña</ControlLabel>}
                {this.props.code != null && <ControlLabel>Código del autenticador</ControlLabel>}

                <InputGroup>
                    <FormControl type={this.state.showPassword ? "text" : "password"}
                        value={this.props.value} onChange={this.onValueChange} />
                    <InputGroup.Button>
                        <Button onClick={this.onEyeClick}><i className={this.state.showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i></Button>
                    </InputGroup.Button>
                </InputGroup>
                {isCompare == null && <ProgressBar bsStyle={this.state.score === 4 ? "success" : "danger"} now={100 / 4 * this.state.score} />}
                <HelpBlock>{helpBlock}</HelpBlock>
            </FormGroup>
        );
    }

}

InputPassword.propTypes = {
    value: PropTypes.string.isRequired,
    compareValue: PropTypes.string,
    onChange: PropTypes.func,
    forceValidation: PropTypes.bool
}

export default InputPassword;


// WEBPACK FOOTER //
// ./src/components/input-password/InputPassword.js